import * as types from '../actions/types';

const initialState = {
    data: [],
    loading: false,
    hasMore: true,
    cancelTicket: {
        error: null,
        loading: false,
        success: false,
        hasResponse: false,
    },
    payWin: {
        error: null,
        loading: false,
        success: false,
        hasResponse: false,
    },
    ticketModal: {
        isVisible: false,
        ticketCode: null,
        loading: false,
        ticket: null,
    },
};

export default function (state = initialState, action) {
    const { type, payload, hasMoreTickets } = action;
    switch (type) {
        case types.GET_TICKETS_REQUEST:
            return { ...state, loading: true };
        case types.GET_TICKETS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: [...state.data, ...payload],
                hasMore: hasMoreTickets,
            };
        case types.CLEAR_TICKETS:
            return { ...state, data: [] };
        case types.TICKET_MODAL_PROPS_CHANGED:
            return {
                ...state,
                ticketModal: {
                    ...state.ticketModal,
                    ...payload,
                },
            };
        case types.TICKET_MODAL_PROPS_RESET:
            return {
                ...state,
                ticketModal: initialState.ticketModal,
            };
        case types.CLEAR_TICKET:
            return {
                ...state,
                ticketModal: initialState.ticketModal,
                cancelTicket: initialState.cancelTicket,
                payWin: initialState.payWin,
            };

        case types.CANCEL_TICKET_REQUEST:
            return {
                ...state,
                cancelTicket: {
                    ...state.cancelTicket,
                    loading: true,
                    error: null,
                    success: false,
                },
            };
        case types.CANCEL_TICKET_SUCCESS:
            return {
                ...state,
                data: state.data.filter(ticket => ticket.code !== action.canceledTicket),
                cancelTicket: {
                    ...state.cancelTicket,
                    loading: false,
                    error: null,
                    success: action.cancelSuccess,
                    hasResponse: true,
                },
            };
        case types.CANCEL_TICKET_FAILED:
            return {
                ...state,
                cancelTicket: {
                    ...state.cancelTicket,
                    loading: false,
                    error: payload,
                    success: false,
                },
            };

        case types.PAY_WIN_REQUEST:
            return {
                ...state,
                payWin: {
                    ...state.payWin,
                    error: null,
                    loading: true,
                    success: false,
                },
            };
        case types.PAY_WIN_SUCCESS:
            return {
                ...state,
                data: state.data.map(ticket => {
                    if (ticket.code === payload.ticketNumber) {
                        ticket.status = payload.ticketStatus;
                    }
                    return ticket;
                }),
                payWin: {
                    ...state.payWin,
                    loading: false,
                    error: null,
                    success: true,
                    hasResponse: true,
                },
            };
        case types.PAY_WIN_FAILED:
            return {
                ...state,
                payWin: {
                    ...state.payWin,
                    loading: false,
                    error: payload,
                    success: false,
                },
            };

        default:
            return state;
    }
}
